import CountDown from '@/components/VideoPlayer/interact/CountDown.vue'
import NormalRed from '@/components/VideoPlayer/interact/NormalRed.vue'
import NormalQue from '@/components/VideoPlayer/interact/NormalQue.vue'
import AllResponse from '@/components/VideoPlayer/interact/AllResponse.vue'
import Common from '@/components/VideoPlayer/interact/Common.vue'
import HitPlane from '@/components/VideoPlayer/interact/HitPlane.vue'
import Gaopin from '@/components/VideoPlayer/interact/Gaopin.vue'
import Danbu from '@/components/VideoPlayer/interact/Danbu.vue'
function getEvent() {
  const useEvent = {
    100: {
      name: '倒计时',
      component: CountDown
    },
    101: {
      name: `普通红包`,
      component: NormalRed
    },
    102: {
      name: `普通答题`,
      component: NormalQue
    },
    104: {
      name: `语音红包`,
      component: HitPlane
    },
    105: {
      name: `语音测评`,
      component: Common
    },
    121: {
      name: `一呼百应`,
      component: AllResponse
    },
    128: {
      name: `单步训练`,
      component: Danbu
    },
    129: {
      name: `打飞机`,
      component: HitPlane
    },
    131: {
      name: `选择题（高频互动）`,
      component: Gaopin
    },
    132: {
      name: `拖拽题（高频互动）`,
      component: Gaopin
    },
    133: {
      name: `大显身手（高频互动）`,
      component: Gaopin
    },
    134: {
      name: `定帧题（高频互动）`,
      component: Gaopin
    }
  }
  Object.keys(useEvent).forEach(type => {
    useEvent[type] = {
      type: Number(type),
      ...useEvent[type]
    }
  })
  return useEvent
}

export default getEvent
